export class NftBalanceResolver {
    constructor(providers) {
        this.providers = providers || [];
    }
    async getBalance({ address, network, contractAddress }) {
        const provider = this.providers.find(p => p.supportsNetwork(network));
        if (!provider) {
            throw new Error(`No provider found for network ${network.name}`);
        }
        return provider.getBalance({ address, network, contractAddress });
    }
}
